import React from 'react';
import SvgIcon from './SvgIcon';

const ServiceNowLogo = props => (
    <SvgIcon viewBox="-26 -24 144 144" {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 62.9842V37.5905H6.49605V39.7559C8.46455 38.1811 10.8268 37.1968 13.5827 37.1968C17.126 37.1968 20.2756 38.7716 22.4409 41.3307C24.0157 43.2992 25.1968 45.8583 25.1968 50.189V63.1811H18.3071V49.5984C18.3071 47.0394 17.7165 45.6614 16.7323 44.874C15.748 43.8897 14.5669 43.2992 12.7953 43.2992C10.0394 43.2992 7.67715 45.0709 6.49605 46.4488V62.9842C6.6929 62.9842 0 62.9842 0 62.9842Z"
                fill="#293E40"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42.7167 37C34.4489 37 27.9529 43.4961 27.9529 51.7638C27.9529 56.0945 29.7245 60.0315 32.4804 62.7874C33.4647 63.7716 35.2363 63.7716 36.4174 62.9842C37.9923 61.6063 40.3544 60.8189 42.7167 60.8189C45.2757 60.8189 47.2442 61.6063 49.0159 62.9842C50.197 63.9685 51.7718 63.7716 52.9529 62.5905C55.7088 59.8346 57.4804 56.0945 57.4804 51.7638C57.2836 43.6929 50.7875 37 42.7167 37ZM42.5198 59.4409C37.9922 59.4409 35.0395 56.0945 35.0395 51.9606C35.0395 47.8268 37.9922 44.4803 42.5198 44.4803C47.0474 44.4803 50.0001 47.8268 50.0001 51.9606C50.0001 56.0945 47.0474 59.4409 42.5198 59.4409Z"
                fill="#81B5A1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M70.8662 62.9842H65.7481L55.7087 37.5905H62.4017L67.9135 52.1575L73.4253 37.5905H79.1339L84.4489 52.1575L89.9607 37.5905H96.8505L86.8111 62.9842H81.693L76.1812 48.6142L70.8662 62.9842Z"
                fill="#293E40"
            />
            <path
                d="M96.8506 60.0315H96.26V61.0157H95.8663V58.063H97.0474C97.638 58.063 98.0317 58.4567 98.0317 59.0472C98.0317 59.4409 97.638 59.8346 97.4411 60.0315L98.2285 61.2126H97.638L96.8506 60.0315ZM96.26 59.6378H97.0474C97.4411 59.6378 97.4411 59.4409 97.4411 59.2441C97.4411 58.8504 97.2443 58.8504 97.0474 58.8504H96.26V59.6378Z"
                fill="#293E40"
            />
            <path
                d="M96.8504 57.0787C98.4252 57.0787 99.6063 58.2598 99.6063 59.8346C99.6063 61.4094 98.4252 62.5905 96.8504 62.5905C95.2756 62.5905 94.0945 61.4094 94.0945 59.8346C94.0945 58.2598 95.4725 57.0787 96.8504 57.0787ZM96.8504 56.4882C95.0788 56.4882 93.7008 58.063 93.7008 59.6378C93.7008 61.4094 95.2756 62.7874 96.8504 62.7874C98.6221 62.7874 100 61.2126 100 59.6378C100 58.063 98.4252 56.4882 96.8504 56.4882Z"
                fill="#293E40"
            />
        </g>
    </SvgIcon>
);

ServiceNowLogo.displayName = 'ServiceNowLogoIcon';

export default ServiceNowLogo;
